// pages/AdminDashboard/index.jsx
import React, { useState } from "react";
import { Container } from "../../styles/components";
import { useAuth } from "../../hooks/useAuth";
import PendingRequests from "../../components/admin/PendingRequests";
import PaymentVerification from "../../components/admin/PaymentVerification";
import ClientsList from "./components/ClientsList";
import SessionsManagement from "./components/SessionsManagement";
import {
    DashboardWrapper,
    DashboardHeader,
    TabsContainer,
    TabList,
    Tab
} from "./styles";

const AdminDashboard = () => {
    const { user } = useAuth();
    const [activeTab, setActiveTab] = useState("requests");

    const renderTabContent = () => {
        switch (activeTab) {
            case "requests":
                return <PendingRequests />;
            case "payments":
                return <PaymentVerification />;
            case "clients":
                return <ClientsList />;
            case "sessions":
                return <SessionsManagement />;
            default:
                return null;
        }
    };

    return (
        <DashboardWrapper>
            <DashboardHeader>
                <Container>
                    <h1>Admin Dashboard</h1>
                    <p>Welcome back, {user?.name}</p>
                </Container>
            </DashboardHeader>

            <Container>
                <TabsContainer>
                    <TabList>
                        <Tab 
                            isActive={activeTab === "requests"}
                            onClick={() => setActiveTab("requests")}
                        >
                            Subscription Requests
                        </Tab>
                        <Tab 
                            isActive={activeTab === "payments"}
                            onClick={() => setActiveTab("payments")}
                        >
                            Payment Verification
                        </Tab>
                        <Tab 
                            isActive={activeTab === "clients"}
                            onClick={() => setActiveTab("clients")}
                        >
                            Clients
                        </Tab>
                        <Tab 
                            isActive={activeTab === "sessions"}
                            onClick={() => setActiveTab("sessions")}
                        >
                            Sessions
                        </Tab>
                    </TabList>

                    {renderTabContent()}
                </TabsContainer>
            </Container>
        </DashboardWrapper>
    );
};

export default AdminDashboard;